module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('v-scale-transition', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "color": _vm.$store.getters.isDarkTheme ? 'grey darken-4' : 'grey lighten-4'
    }
  }, [_c('v-toolbar', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "flat": "",
      "color": ("green " + (_vm.$store.getters.isDarkTheme ? 'darken-2' : 'lighten-2'))
    },
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("filter_list")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('filtrar-rango-valores')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.collapsed ? 'add' : 'remove'))])], 1)], 1), _vm._v(" "), _c('v-slide-y-transition', [_c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "px-3 py-0"
  }, [_c('v-layout', {
    staticClass: "pb-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-range-slider', {
    staticClass: "px-1",
    attrs: {
      "hide-details": "",
      "thumb-label": true,
      "max": _vm.maxLimit,
      "min": _vm.minLimit,
      "step": _vm.step
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minColor),
      expression: "minColor"
    }],
    staticClass: "px-1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.minColor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minColor = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxColor),
      expression: "maxColor"
    }],
    staticClass: "px-1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.maxColor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxColor = $event.target.value
      }
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('v-slide-y-transition', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-text', {
    staticClass: "px-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mr-1"
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_vm._v("\n                    Mín: " + _vm._s(_vm.values[0].toFixed(2)) + "\n                  ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "ml-1"
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_vm._v("\n                    Máx: " + _vm._s(_vm.values[1].toFixed(2)) + "\n                  ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05a605b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/utils/shared-components/raster-range-filter.vue
// module id = 1041
// module chunks = 1